import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getCarModels,
  getModelWiseComposiion,
  getModelWiseData,
  getModelWiseReport,
  getModelWiseTableData,
} from "../api/modelWise";

export const fetchCarModels = createAsyncThunk(
  "modelWise/fetchCarModels",
  async (params) => getCarModels(params?.search)
);

export const fetchModelWiseData = createAsyncThunk(
  "modelWise/fetchModelWiseData",
  async (params) =>
    getModelWiseData(
      params?.value,
      params?.location,
      params?.model,
      params?.page,
      params?.limit,
      params?.sort
    )
);

export const fetchModelWiseComposition = createAsyncThunk(
  "modelWise/fetchModelWiseComposition",
  async (params) =>
    getModelWiseComposiion(
      params?.value,
      params?.location,
      params?.model,
      params?.page,
      params?.limit,
      params?.sort
    )
);

export const fetchModelWiseReport = createAsyncThunk(
  "modelWise/fetchModelWiseReport",
  async (params) => getModelWiseReport(params?.location)
);

export const fetchModelWiseTableData = createAsyncThunk(
  "modelWise/fetchModelWiseTableData",
  async (params) =>
    getModelWiseTableData(
      params?.location,
      params?.model,
      params?.page,
      params?.limit
    )
);

export const modelWiseSlice = createSlice({
  name: "modelWise",
  initialState: {
    carModelDetails: null,
    modelWiseData: null,
    modelWiseComposition: null,
    modelWiseReport: null,
    modelWiseTableData: null,
    loading: false,
  },
  reducers: {
    resetModelWiseTableData: (state, { payload }) => {
      state.modelWiseTableData = null;
    },
  },
  extraReducers: {
    [fetchCarModels.fulfilled]: (state, { payload }) => {
      state.carModelDetails = payload;
    },
    [fetchModelWiseData.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchModelWiseData.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.modelWiseData = payload;
    },
    [fetchModelWiseData.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [fetchModelWiseComposition.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchModelWiseComposition.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.modelWiseComposition = payload;
    },
    [fetchModelWiseComposition.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [fetchModelWiseReport.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchModelWiseReport.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.modelWiseReport = payload;
    },
    [fetchModelWiseReport.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [fetchModelWiseTableData.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchModelWiseTableData.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.modelWiseTableData = payload;
    },
    [fetchModelWiseTableData.rejected]: (state, { payload }) => {
      state.loading = false;
    },
  },
});

export default modelWiseSlice.reducer;
export const { resetModelWiseTableData } = modelWiseSlice.actions;
